import { render } from "./Authorize.vue?vue&type=template&id=f52ac216&scoped=true"
import script from "./Authorize.vue?vue&type=script&lang=js"
export * from "./Authorize.vue?vue&type=script&lang=js"

import "./Authorize.vue?vue&type=style&index=0&id=f52ac216&lang=scss&scoped=true"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52ac216"]])

export default __exports__